var React = require('react');

function IconFacebookInline (props) {
    return React.createElement("path",props);
}

IconFacebookInline.defaultProps = {"d":"M47,23.6436165 C47,10.5855981 36.4787012,0 23.5,0 C10.5212988,0 0,10.5855981 0,23.6436165 C0,35.4448289 8.59361035,45.226267 19.828125,47 L19.828125,30.4780994 L13.8613281,30.4780994 L13.8613281,23.6436165 L19.828125,23.6436165 L19.828125,18.4346322 C19.828125,12.5089509 23.3365098,9.23578769 28.7044238,9.23578769 C31.2755166,9.23578769 33.9648438,9.69757708 33.9648438,9.69757708 L33.9648438,15.5161233 L31.0015488,15.5161233 C28.0822705,15.5161233 27.171875,17.3386675 27.171875,19.2084527 L27.171875,23.6436165 L33.6894531,23.6436165 L32.6475586,30.4780994 L27.171875,30.4780994 L27.171875,47 C38.4063896,45.226267 47,35.4448289 47,23.6436165"};

module.exports = IconFacebookInline;

IconFacebookInline.default = IconFacebookInline;
